import { Box, Typography, Collapse } from "@mui/material";
import { useEffect } from "react";
import { FC, useContext } from "react";
import { useTabContext } from "../../context/tabs/TabContext";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import AddIcon from "@mui/icons-material/Add";
import { IStatistics } from "../../common/interfaces/statistic.interface";
import { PeriodFilter } from "../../common/enums/common.enums";
import { round } from "../../utils/helpers";

interface ISideInfo {
  statisticsData: IStatistics | undefined;
  type?: string;
}

const SideInfo: FC<ISideInfo> = ({ statisticsData, type = "clubs" }) => {
  const { tab, changeTab } = useContext(useTabContext);

  useEffect(() => {
    if (!tab) {
      changeTab(PeriodFilter.DAILY);
    }
  }, [tab]);

  return (
    <div>
      <Box
        sx={{
          width: "100%",
          borderRadius: 1.5,
        }}
      >
        {statisticsData &&
          Object.values(statisticsData).map((child, index) =>
            tab ? (
              <Collapse
                orientation="vertical"
                in={tab.toUpperCase() === child.id.toUpperCase()}
                key={index}
              >
                <Box
                  sx={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "flex-start",
                    flexDirection: "row",
                    padding: "10px",
                  }}
                >
                  <Box
                    key={`${index}_box1`}
                    sx={{
                      borderRadius: 1.5,
                    }}
                  >
                    <Typography
                      variant="body2"
                      component="span"
                      key={`${index}_typography1`}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        borderImageSlice: 1,
                        padding: 1,
                        width: "100%",
                      }}
                    >
                      {statisticsData && statisticsData[tab].label}
                    </Typography>
                  </Box>
                  <Box
                    key={`${index}_box2`}
                    sx={{
                      borderRadius: 1.5,
                      padding: "0 16px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <AddIcon
                      key={`${index}_addIcon`}
                      color="primary"
                      sx={{
                        marginRight: 1,
                      }}
                    />
                    <Typography
                      key={`${index}_typography2`}
                      sx={{
                        color: "white",
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "start",
                      }}
                      variant="body2"
                      component="span"
                    >
                      {statisticsData && round(statisticsData[tab].value)} new{" "}
                      {type}
                    </Typography>
                  </Box>
                  <Box
                    key={`${index}_box3`}
                    sx={{
                      borderRadius: 1.5,
                      padding: "0 16px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {(statisticsData && statisticsData[tab].compared === 0) ||
                    statisticsData[tab].compared >= 100 ? (
                      <>
                        <TrendingUpIcon
                          key={`${index}_trendingUpIcon1`}
                          color="primary"
                          sx={{
                            marginRight: 1,
                          }}
                        />
                        <Typography
                          key={`${index}_typography3`}
                          sx={{
                            color: "white",
                            display: "flex",
                            width: "100%",
                            alignItems: "center",
                            justifyContent: "start",
                          }}
                          variant="body2"
                          component="span"
                        >
                          {statisticsData &&
                            Math.round(statisticsData[tab].compared)}
                          % compared to previous
                        </Typography>
                      </>
                    ) : (
                      <>
                        <TrendingDownIcon
                          key={`${index}_trendingDownIcon1`}
                          color="error"
                          sx={{
                            marginRight: 1,
                          }}
                        />
                        <Typography
                          key={`${index}_typography3`}
                          sx={{
                            color: "white",
                            display: "flex",
                            width: "100%",
                            alignItems: "center",
                            justifyContent: "start",
                          }}
                          variant="body2"
                          component="span"
                        >
                          {statisticsData &&
                            100 - Math.round(statisticsData[tab].compared)}
                          % compared to previous
                        </Typography>
                      </>
                    )}
                  </Box>
                </Box>
              </Collapse>
            ) : (
              <div></div>
            )
          )}
      </Box>
    </div>
  );
};

export default SideInfo;
